import { Question } from '../../question.class';
import { Option } from '../../../option';
import { removeEmptyNumberOptions } from '../functions/removeEmptyNumberOptions.fn';
import { populateEmptyNumberOptions } from '../functions/populateEmptyNumberOptions.fn';

const type = 'checkbox';

let QuestionOnComposeInit = Question.prototype.onComposeInit;
Question.prototype.onComposeInit = function(...args) {
  if (args[0] === type) {
    populateEmptyNumberOptions(this);
    QuestionOnComposeInit.apply(this, args);
  } else {
    QuestionOnComposeInit.apply(this, args);
  }
};
let QuestionOnComposeDestroy = Question.prototype.onComposeDestroy;
Question.prototype.onComposeDestroy = function(...args) {
  if (args[0] === type) {
    removeEmptyNumberOptions(this);
    QuestionOnComposeDestroy.apply(this, args);
  } else {
    QuestionOnComposeDestroy.apply(this, args);
  }
};

let OptionOnComposeFocusFn = Option.prototype.onComposeFocus;
Option.prototype.onComposeFocus = function(...args) {
  if (this.question.type === type) {
    populateEmptyNumberOptions(this.question);
    OptionOnComposeFocusFn.apply(this, args);
  } else {
    OptionOnComposeFocusFn.apply(this, args);
  }
};
let QuestionOnComposeFocusFn = Question.prototype.onComposeFocus;
Question.prototype.onComposeFocus = function(...args) {
  if (this.type === type) {
    populateEmptyNumberOptions(this);
    QuestionOnComposeFocusFn.apply(this, args);
  } else {
    QuestionOnComposeFocusFn.apply(this, args);
  }
};

let QuestionOnComposeBlur = Question.prototype.onComposeBlur;
Question.prototype.onComposeBlur = function(...args) {
  if (this.type === type) {
    removeEmptyNumberOptions(this);
    QuestionOnComposeBlur.apply(this, args);
  } else {
    QuestionOnComposeBlur.apply(this, args);
  }
};
console.log("question type checkbox is added");